import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { GetProductAnalyticsConfigResponse } from './models';
import { apiBaseUrl } from 'lib.shared/src/api';

/**
 * Raw base query without reauth: the endpoint is public and is used by guest
 * surfaces (the partner start page), where a 401 must never trigger the login
 * redirect. Cookies are essential rather than incidental — the visitor identity
 * the response returns rides in one.
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  credentials: 'include',
});

export const productAnalyticsApi = createApi({
  reducerPath: 'product_analytics',
  baseQuery: rawBaseQuery,
  tagTypes: ['product_analytics'],
  endpoints: (build) => ({
    getProductAnalyticsConfig: build.query<GetProductAnalyticsConfigResponse, void>({
      query: () => ({
        url: '/analytics/config',
        headers: { Accept: 'application/json' },
      }),
      providesTags: [{ type: 'product_analytics', id: 'CONFIG' }],
    }),
  }),
});

export const { useGetProductAnalyticsConfigQuery } = productAnalyticsApi;
